import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import DocumentTemplateIcon from 'assets/document-template-icon.svg';

import { ButtonPrimary } from '@yuhu-inc/yuhui';

const StyledButtonContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 10px;
  ${media.mobile`
    width: 100%;
    padding: 8px 10px;
  `};
`;

const StyledBorder = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 18px 24px;
  height: 100%;
  width: 100%;
  ${media.mobile`
    padding: 18px 18px;
  `};
`;

const StyledIcon = styled.img`
  width: 180px;
  height: 180px;
  ${media.mobile`
    width: 130px;
    height: 130px;
  `};
`;

const StyledArchivedActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 80px;
  ${media.mobile`
    padding: 10px;
  `};
`;

const StyledArchivedActionTitle = styled.h4`
  margin-top: 12px;
  margin-bottom: 0px;
  text-align: center;
  font-size: 14px;
`;

const StyledArchivedActionVerbiage = styled.p`
  margin-top: 5px;
  margin-bottom: 0px;
  text-align: center;
  color: #65666d;
`;

const StyledUnarchiveButton = styled(ButtonPrimary)`
  margin-top: 25px;
  width: max-content;
  align-self: center;
  background-color: transparent !important;
`;

export const ArchivedActionPane = ({ handleArchive, archiveButtonText }) => {
  return (
    <StyledButtonContainer>
      <StyledBorder>
        <StyledArchivedActionContainer>
          <StyledIcon src={DocumentTemplateIcon} />
          <StyledArchivedActionTitle>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.templateArchived')}
          </StyledArchivedActionTitle>
          <StyledArchivedActionVerbiage>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.unarchiveMakeChanges')}
          </StyledArchivedActionVerbiage>
          <StyledUnarchiveButton
            type="button"
            contentKey={archiveButtonText}
            onClick={handleArchive}
            style={{
              marginTop: '15px',
            }}
          />
        </StyledArchivedActionContainer>
      </StyledBorder>
    </StyledButtonContainer>
  );
};
